import React from "react";
import {Box} from "@mui/material";
import PerformanceMetrics from "../Utilities/PerformanceMetrics";
import CampaignsTable from "../Utilities/CampaignsTable";
import useGetRetainCampaigns from "../Utilities/hooks/useGetRetainCampaigns";
import {MetricsDetailFooter as Footer} from "../../MetricsDetail/Sections";
import {SnackBar} from "../../../../common/SnackBar";

export default function CompanyRetainDashboard() {
    const {rows, columns, totalCount, loading, changePage, page} = useGetRetainCampaigns()

    const handlePageChange = (event, nextPage) => {
        changePage(nextPage)
    };

    const handleTableCellClick = (params) => {
        if (params) {
            window.location.replace(params);
        } else {
            SnackBar.showMessage("Please browse the messages on the source platform.");
        }
    }

    return(
        <Box sx={{backgroundColor: '#EDEDE4'}}>
            <Box sx={styles.root}>
                <Box sx={styles.container}>
                    <Box>
                        <Box component={'h1'} sx={styles.headingLarge}>
                            Retain
                        </Box>
                        <PerformanceMetrics />
                    </Box>

                    <Box mt={{ xs: '30px', sm: '42px', }}>
                        <Box component={'h2'} sx={styles.headingSmall}>
                            All Campaigns
                        </Box>
                        <CampaignsTable
                            rows={rows}
                            columns={columns}
                            totalCount={totalCount}
                            loading={loading}
                            page={page}
                            handlePageChange={handlePageChange}
                            handleTableCellClick={handleTableCellClick}
                        />
                    </Box>
                </Box>
            </Box>
            <Footer />
        </Box>
    )
}

const styles = {
    root: {
        fontFamily: 'FustatMedium',
        letterSpacing: '-0.02em',
        color: '#302E2A',
        pt: 13,
        minHeight: '100vh',
    },
    container: {
        maxWidth: '1440px',
        position: 'relative',
        mx: 'auto',
    },
    headingLarge: {
        mb: 0,
        fontFamily: 'IvyPrestoHeadlineRegular',
        fontSize: '35px',
        lineHeight: 1.2,
        letterSpacing: '0.03em',
    },
    headingSmall: {
        fontFamily: 'FustatBold',
        fontSize: '17px',
        letterSpacing: '0.01em',
    }
}